import React from 'react';
import Icon from './Icon';
import '../styles/modal.css';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isClosing: false
    };
  }

  componentDidMount() {
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    // Restore body scroll when modal is closed
    document.body.style.overflow = 'unset';
  }

  handleClose = () => {
    // Start the fade-out animation
    this.setState({ isClosing: true });
    // Wait for animation to complete before calling onClose
    setTimeout(() => {
      this.props.onClose();
    }, 300); // Match the CSS animation duration
  };

  handleOverlayClick = (e) => {
    // Only close if clicking the overlay itself, not the content
    if (e.target === e.currentTarget) {
      this.handleClose();
    }
  };

  render() {
    const { children, showCloseButton = true } = this.props;
    const { isClosing } = this.state;

    return (
      <div
        className={`modal-overlay ${isClosing ? 'closing' : ''}`}
        onClick={this.handleOverlayClick}
      >
        {showCloseButton && (
          <Icon icon="xmark" className="opacity-hover modal-close" onClick={this.handleClose}/>
        )}
        <div className="modal-content">
          {children}
        </div>
      </div>
    );
  }
}

export default Modal;
